import { Pipe, PipeTransform } from '@angular/core';
import { NaUtils } from '@ng-arthur/common';

/**
 * å¤æ­æ¯å¦ä¸ºç©º
 * ä¸ºç©ºæ¶è¿åtrue
 * éç©ºæ¶è¿åfalse
 *
 * @export
 * @class NaIsNullOrEmptyPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'NaIsNullOrEmpty'
})
export class NaIsNullOrEmptyPipe implements PipeTransform {
  transform(value: any): any {
    return NaUtils.isNullOrEmpty(value);
  }
}
